// API клиент для матрицы доступов по ЛПУ
// Source: design-rls-admin-ui-2026-04-12.md section 1.2
import { apiClient } from './client'

// ---------------------------------------------------------------------------
// Types (соответствуют backend schemas в lpu_access_matrix.py)
// ---------------------------------------------------------------------------

export interface RlsPattern {
  /** all | userid */
  fil: string
  podr: string
  srv: string
  otd: string
}

export interface AccessGroupItem {
  name: string
  zitadel_role_key: string
  members_count: number
  /** full | fil | podr | srv | otd | unknown */
  access_level: string
  rls_pattern: RlsPattern
}

export interface RlsBindings {
  /** '*' = ALL, код = конкретный объект, null = не задано */
  fil: string | null
  podr: string | null
  srv: string | null
  otd: string | null
}

export interface AccessMatrixUser {
  email: string
  display_name: string
  /** список zitadel_role_key групп пользователя */
  groups: string[]
  rls_bindings: RlsBindings
  /** есть ли запись в CH mdc01_{code}.rls_access */
  ch_rls_access_exists: boolean
  /** 'no_ch_rls_record' | ... */
  warnings: string[]
}

export interface AccessMatrixResponse {
  lpu_code: string
  lpu_name: string
  groups: AccessGroupItem[]
  users: AccessMatrixUser[]
}

// ---------------------------------------------------------------------------
// API function
// ---------------------------------------------------------------------------

export const fetchLpuAccessMatrix = async (
  code: string,
): Promise<AccessMatrixResponse> => {
  const response = await apiClient.get<AccessMatrixResponse>(
    `/lpu/${code}/access-matrix`,
  )
  return response.data
}
